<template>
  <div class="home-wrapper">
    <div class="header">
      <div class="brand">
        <img src="@/assets/imgs/logo.png" alt="logo">
        <i class="iconfont icon-nav"
          @click="isCollapse = !isCollapse"></i>
      </div>

      <div class="info">
        <i class="iconfont icon-my"></i>
        <router-link :to="{ name: 'Login' }" v-if="JSON.stringify(userInfo) === '{}'">请登录</router-link>
        <el-dropdown v-else>
          <span class="el-dropdown-link">
            {{ userInfo.username }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <div class="main">
      <div class="nav">
        <el-menu
          :default-active="path"
          class="nav-menu"
          :collapse="isCollapse"
          :router="true">

          <el-submenu index="/op/user" v-if="hasResCate('user') || hasResCate('agent')">
            <template slot="title">
              <i class="iconfont icon-my" ></i>
              <span slot="title">商户管理</span>
            </template>
            <el-menu-item index="/op/user" v-if="hasResCate('user')">商户管理</el-menu-item>
            <el-menu-item index="/op/agent" v-if="hasResCate('agent')">代理商管理</el-menu-item>
          </el-submenu>

          <el-submenu index="/op/store" v-if="hasResCate('store')">
            <template slot="title">
              <i class="iconfont icon-app"></i>
              <span slot="title">套餐管理</span>
            </template>
            <el-menu-item index="/op/store/app_category">应用分类管理</el-menu-item>
            <el-menu-item index="/op/store/app">应用管理</el-menu-item>
            <el-menu-item index="/op/store/app_extend">扩展参数管理</el-menu-item>
          </el-submenu>

          <el-menu-item index="/op/bill" v-if="hasResCate('bill')">
            <i class="iconfont icon-dingdan"></i>
            <span slot="title">订单管理</span>
          </el-menu-item>

          <el-menu-item index="/op/dev" v-if="hasResCate('dev')">
            <i class="iconfont icon-fanmaiji"></i>
            <span slot="title">设备管理</span>
          </el-menu-item>

          <el-submenu index="/op/app" v-if="hasResCate('app') || hasResCate('bin')">
            <template slot="title">
              <i class="iconfont icon-app"></i>
              <span slot="title">应用管理</span>
            </template>
            <el-menu-item index="/op/app" v-if="hasResCate('app')">应用管理</el-menu-item>
            <el-menu-item index="/op/bin" v-if="hasResCate('bin')">升级包管理</el-menu-item>
          </el-submenu>

          <el-submenu index="/op/factory" v-if="hasResCate('factory') || hasResCate('adv_registry')">
            <template slot="title">
              <i class="iconfont icon-wuliaochangshang"></i>
              <span slot="title">生产管理</span>
            </template>
            <el-menu-item index="/op/adv_registry" v-if="hasResCate('adv_registry')">预生产管理</el-menu-item>
            <el-menu-item index="/op/factory" v-if="hasRes('factory_index')">厂商管理</el-menu-item>
            <el-menu-item index="/op/dev_tools" v-if="hasResCate('factory')">开发工具</el-menu-item>
          </el-submenu>

          <el-submenu index="/op/merchant_create" v-if="hasResCate('merchant') || hasResCate('split_account')">
            <template slot="title">
              <i class="iconfont icon-card"></i>
              <span slot="title">资金管理</span>
            </template>
            <el-menu-item index="/op/merchant_info_supply" v-if="hasResCate('merchant')">商户入件</el-menu-item>
            <el-menu-item index="/op/split_account" v-if="hasResCate('split_account')">分账审核</el-menu-item>
          </el-submenu>

          <el-submenu index="/op/op_user" v-if="isAdmin">
            <template slot="title">
              <i class="iconfont icon-safe"></i>
              <span slot="title">权限管理</span>
            </template>
            <el-menu-item index="/op/op_user">运维用户管理</el-menu-item>
            <el-menu-item index="/op/op_role">角色管理</el-menu-item>
            <el-menu-item index="/op/op_resource">权限资源</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>

      <div class="content">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'Home',
  data () {
    return {
      isCollapse: false
    }
  },
  computed: {
    ...mapState('opUser', [
      'userInfo'
    ]),
    ...mapGetters('opUser', [
      'hasResCate',
      'hasRes',
      'isAdmin'
    ]),
    path () {
      return this.$route.path
    }
  },
  methods: {
    ...mapMutations('opUser', [
      'exit'
    ]),

    logout () {
      this.exit()
      this.$router.push({
        name: 'Login'
      })
      this.$message({
        type: 'success',
        message: '退出登录'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/sass/base";

.home-wrapper {

  .header {
    background: $primaryColor;
    height: 3.6rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 2rem;
    color: $primaryTextColor;

    .brand {
      display: flex;
      align-items: center;

      img {
        height: 1.8rem;
      }
      i {
        font-size: 1.8rem;
        margin-left: 1rem;
        cursor: pointer;
      }
    }

    .info {
      i {
        font-size: 1.2rem;
      }
      a {
        font-size: 1.0rem;
        color: $primaryTextColor;
        text-decoration: none;
      }
      span {
        margin-left: .8rem;
      }

      .el-dropdown-link {
        cursor: pointer;
        color: $primaryTextColor;
      }
      .el-icon-arrow-down {
        font-size: 12px;
      }
    }
  }

  .main {
    display: flex;
    justify-content: space-between;
    min-height: calc(100vh - 3.6rem);
    background: #f0f2f5;

    .nav {
      background: $primaryColor;

      .nav-menu {
        height: 100%;
        // border: none;

        .iconfont {
          margin-right: 5px;
          font-size: 18px;
          vertical-align: middle;
        }

        .el-submenu {
          .el-menu-item {
            min-width: 180px;
          }
        }
      }

      .nav-menu:not(.el-menu--collapse) {
        width: 180px;
      }
    }

    .content {
      flex: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue